@use 'src/global/variables.scss' as var;

c-avatar-button{
    cursor: crosshair;
}